import { datadogRum } from "@datadog/browser-rum";

export interface GenAIValidationError {
    resources: string[];
    field: string;
    code: string;
    message: string;
}

export interface GenAIValidationResponse {
    canDisable: boolean;
    productGroupNames?: string[];
    otherGroupNames?: string[];
}

export class GenAIValidation {
    canDisable: boolean;
    productGroupNames: string[];
    otherGroupNames: string[];

    constructor(response: GenAIValidationResponse) {
        this.canDisable = response.canDisable;
        this.productGroupNames = response.productGroupNames || [];
        this.otherGroupNames = response.otherGroupNames || [];
    }

    static fromErrorResponse(errors: GenAIValidationError[]): GenAIValidation {
        const productGroupNames: string[] = [];
        const otherGroupNames: string[] = [];

        errors.forEach((error) => {
            if (error.code === "UsersInOpalProductGroups") {
                productGroupNames.push(...error.resources);
            } else if (error.code === "UsersInOpalCustomGroups") {
                otherGroupNames.push(...error.resources);
            } else {
                // Unknown error code - log for visibility and default to other groups
                datadogRum.addError(new Error(`Unknown GenAI validation error code: ${error.code}`), {
                    errorCode: error.code,
                    errorMessage: error.message,
                    resources: error.resources
                });
                otherGroupNames.push(...error.resources);
            }
        });

        return new GenAIValidation({
            canDisable: false,
            productGroupNames,
            otherGroupNames
        });
    }

    get requiresCleanup(): boolean {
        return !this.canDisable;
    }

    get hasProductGroups(): boolean {
        return this.productGroupNames.length > 0;
    }

    get hasOtherGroups(): boolean {
        return this.otherGroupNames.length > 0;
    }
}
